export class LocalCache<Key, Value> {
  private _cache: Map<Key, Value | undefined> = new Map();

  private readonly getNewValueForKey: (key: Key) => Promise<Value>;

  private readonly onValueChange: (key: Key, value: Value) => void;

  constructor({
    getNewValueForKey,
    onValueChange,
  }: {
    getNewValueForKey: (key: Key) => Promise<Value>;
    onValueChange: (key: Key, value: Value) => void;
  }) {
    this.getNewValueForKey = getNewValueForKey;
    this.onValueChange = onValueChange;
  }

  private async refreshKey(key: Key) {
    const currentValue = this._cache.get(key);

    if (currentValue === undefined) {
      this._cache = this._cache.set(key, undefined);
    }

    const newValue = await this.getNewValueForKey(key);

    if (currentValue !== newValue) {
      this._cache = this._cache.set(key, newValue);
      this.onValueChange(key, newValue);
    }
  }

  getOrFetchValue(key: Key) {
    const value = this._cache.get(key);

    if (value === undefined) {
      // We throw the promise to enable suspense api fallback when the value is not yet fetched. @TODO: refactor to use config cat react sdk
      throw this.refreshKey(key);
    }
    return value;
  }

  invalidate() {
    this._cache.forEach((_, key) => {
      this.refreshKey(key);
    });
  }
}
